import {
    EncryptMethod,
    FIXParser,
    Field,
    Fields,
    LicenseManager,
    Messages,
    type Options,
    ResetSeqNumFlag,
} from 'fixparser';
import { ConsoleLogTransport } from 'fixparser-plugin-log-console';
import { MCPRemote } from './mcp/MCPRemote';

const initializeServer = async () => {
    await LicenseManager.setLicenseKey(process.env.FIXPARSER_LICENSE_KEY!);
    const SENDER = process.env.FIXPARSER_SENDER || 'SENDER';
    const TARGET = process.env.FIXPARSER_TARGET || 'TARGET';

    const fixParser: FIXParser = new FIXParser({
        plugins: [new MCPRemote({ port: 3099, onReady: () => console.log('ready!') })],
    });

    const sendLogon = () => {
        const logon = fixParser.createMessage(
            new Field(Fields.MsgType, Messages.Logon),
            new Field(Fields.MsgSeqNum, fixParser.getNextTargetMsgSeqNum()),
            new Field(Fields.SenderCompID, SENDER),
            new Field(Fields.SendingTime, fixParser.getTimestamp()),
            new Field(Fields.TargetCompID, TARGET),
            new Field(Fields.ResetSeqNumFlag, ResetSeqNumFlag.Yes),
            new Field(Fields.EncryptMethod, EncryptMethod.None),
            new Field(Fields.HeartBtInt, 10),
        );
        const messages = fixParser.parse(logon.encode());
        console.log('sending message', messages[0].description, messages[0].messageString);
        fixParser.send(logon);
    };

    const CONNECT_PARAMS: Options = {
        host: process.env.FIXPARSER_HOST || '10.0.1.42',
        port: process.env.FIXPARSER_PORT ? Number.parseInt(process.env.FIXPARSER_PORT, 10) : 5001,
        protocol: 'tcp',
        sender: SENDER,
        target: TARGET,
        fixVersion: 'FIX.4.4',
        logging: true,
        logOptions: {
            name: SENDER,
            level: 'info',
            format: 'json',
            transport: new ConsoleLogTransport({ format: 'console' }),
        },
        onOpen: () => {
            console.log('Open');
            sendLogon();
        },
        onClose: () => {
            fixParser.logger.log({
                level: 'info',
                message: 'FIXParser disconnected. Reconnecting in 1 second...',
            });
            setTimeout(() => {
                fixParser.connect(CONNECT_PARAMS);
            }, 1000);
        },
    };

    fixParser.connect(CONNECT_PARAMS);
};

initializeServer().catch((err) => console.error('Error initializing server:', err));
